import React, { Component } from "react";
import EventCard from "../components/eventCard";
import { BrowserRouter as Router, Link } from "react-router-dom";
import diningForDollars from "../files/diningForDollars.jpg";
import downloadIcon from "../icons/downloadIcon.png";
import jeans from "../images/jeans.jpg"
const bookSaleInfo =
  "There's another Book Sale coming soon!  3,000+ books to peruse. Old and New!  Something for everyone, every age, action packed to cook book. Date and time yet to be announced.";

const eventCard4Mobile = (
<EventCard
    eventImage={jeans}
    title={"Dining for Dollars"}
    information={
      <>
      Each meal bought, in-house or to-go, donates $1 per meal to benefit the
      future Union Gap Library and Community Center.
      <br />
      <br /> 
      <b>Join Us for Thirst For Knowledge Thursdays!</b> Third Thursday of June, July and August 2025.

      <br /> 
      <br /> 
      <u>Upcoming Dining for Dollars in:</u><br /> 
      <b>April 2025</b> - Old Town Station<br /> 
      <b>May 2025 </b>- Jeans Cottage Inn<br /> 
      <b>August 2025 </b>- TBA<br /> 
      <b>September 2025 -TBA </b><br /> 
     <b>Donor Dinner October 9th, 2025</b>  - Union Gap Community Center<br/>
     <b>November 2025</b>  -TBA <br /> 
    </>
    }
    
    width={"85%"}
    height={"auto"}
   /* startDate={"TBA"}
    endDate={"TBA"}
    startTime={"TBA"}
    endTime={"TBA"}
    location={"TBA"}
    */
    content= {<div>
    <Router>
      <div     >
        <Link to={diningForDollars} target="_blank" className="downloadLink"  >
        <img className="downloadIcon" src={downloadIcon} alt=""></img> Dining for Dollars Info
        </Link>
      </div>
    </Router>
  </div>
    }
  ></EventCard>
);
class eventsMobile4 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="eventsParent">
          <div className="eventsContainer">
            <h1 className="eventsHeading">Events / Fundraisers</h1>
            <div className="eventCardContainerMobile">{eventCard4Mobile} </div>
          </div>
        </div>
      </div>
    );
  }
}

export default eventsMobile4;
